import React from "react";
import { createPortal } from "react-dom";
import "../../styles/modal.css";

const CustomModal = ({
  isOpen,
  onClose,
  children,
  className = "",
  style = {},
}) => {
  if (!isOpen) return null;

  return createPortal(
    <div className="modal-overlay">
      <div
        className={`modalContent ${className}`}
        onClose={onClose}
        style={style}
      >
        <button className="modal-close-btn" onClick={onClose}>
          <img
            src="/images/close.svg"
            className="CloseIcon CustomModalCloseIcon"
            alt="Close"
          />
        </button>
        {children}
      </div>
    </div>,
    document.getElementById("modal-root")
  );
};

export default CustomModal;
